import React from 'react';
import moment from 'moment';

import EventIcon from './event-icon';
import style from './index.less';

import { field } from '@/apps/setting/pages/customer-setting/constants';
const { fieldConfig } = field;

const MessageEventEvalution = props => {
  const { data } = props;
  const { action, content, time, subType, agentName } = data;
  const date = moment
    .utc(time)
    .local()
    .format('MM/DD HH:mm:ss');
  const SystemNames = Object.keys(fieldConfig);

  return (
    <div className={style['event-box']}>
      {subType === 'ask' && (
        <>
          <ul className={style.header}>
            <li>
              <EventIcon action={action} />
            </li>
            <li className={style.date}>{date}</li>
            <li>{agentName}</li>
            <li>{'发送字段'}</li>
          </ul>
          <div className={style['event-border']} />
          <div className={style['evaluation-content']}>
            {content.map((item, idx) => {
              const { name, value } = item;
              const suffix = idx === content.length - 1 ? '' : '/';
              return `${SystemNames.includes(value) ? String(name ?? '') : name}${suffix}`;
            })}
          </div>
        </>
      )}
      {subType === 'get' && (
        <>
          <ul className={style.header}>
            <li>
              <EventIcon action={action} />
            </li>
            <li className={style.date}>{date}</li>
            <li>{'顾客'}</li>
            <li>{'提交字段'}</li>
          </ul>
          <div className={style['event-border']} />
          <div className={style['evaluation-content']}>
            {content.map(item => {
              const { label, value } = item;
              return (
                <div key={`${label}_${label}`}>
                  {label}：{typeof value === 'object' && value !== null ? '' : value}
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

export default MessageEventEvalution;
